<template>
  <form-template @send-data="sendData" @delete-data="deleteData" :mode="mode">
    <v-text-field
      class="required"
      label="Projekt Name"
      v-model.trim="input.name"
      :rules="rules.name"
    ></v-text-field>
    <p><span style="color: red">*</span> notwendige Eingabe</p>
    <br />
  </form-template>
</template>

<script lang="ts">
import FormTemplate from "./FormTemplate.vue";
import { mapStores } from "pinia";
import { useOfficeStore } from "../../store/officeStore";

export default {
  data() {
    return {
      input: {
        name: null as string | null,
      },
      rules: {
        name: [
          (val: string) => {
            if (!val) {
              return "Name notwendig.";
            }
            return val.length > 0 || "Name notwendig.";
          },
        ],
      },
    };
  },
  props: {
    name: {
      type: String || null,
      required: false,
      default: null,
    },
    mode: {
      type: String || null,
      required: true,
      validator(val: string) {
        return val === "post" || val === "put";
      },
    },
    currentId: {
      type: Number || null,
      required: false,
      default: null,
    },
  },
  components: { FormTemplate },
  computed: {
    ...mapStores(useOfficeStore),
  },
  mounted() {
    // @ts-ignore
    if (this.mode === "put") {
      // @ts-ignore
      this.input.name = this.name;
    }
  },
  watch: {
    mode(newVal) {
      if (newVal === "put") {
        // @ts-ignore
        this.input.name = this.name;
      } else {
        this.input.name = null;
      }
    },
  },
  emits: {
    "post-project": () => {
      return true;
    },
    "put-project": () => {
      return true;
    },
    "delete-project": () => {
      return true;
    },
  },
  methods: {
    async sendData() {
      let project: object = {
        name: this.input.name,
      };
      // @ts-ignore
      if (this.mode === "post") {
        try {
          await this.officeStore.postProject(project);
          this.$emit("post-project");
        } catch (e) {
          // @ts-ignore
          console.warn(`could not post project, message: ${e.message}`);
        }
      } else {
        // @ts-ignore
        if (this.currentId) {
          // @ts-ignore
          project["id"] = this.currentId;
          try {
            await this.officeStore.putProject(project);
            this.$emit("put-project");
          } catch (e) {
            // @ts-ignore
            console.warn(`could not post project, message: ${e.message}`);
          }
        }
      }
    },
    async deleteData() {
      // @ts-ignore
      if (!this.currentId) {
        console.warn("tried to delete project without id");
        return;
      }
      try {
        // @ts-ignore
        await this.officeStore.deleteProject(this.currentId);
        this.$emit("delete-project");
      } catch (e) {
        // @ts-ignore
        console.warn(`could not post project, message: ${e.message}`);
      }
    },
  },
};
</script>

<style>
.required label::after {
  content: " *";
  color: red;
}
</style>
